import GoogleMyBusinessIconSvg from '../../../../img/logos/googleMyBusiness.svg';
import { createSVGComponentFromSVG } from './create-svg-components-from-svg';

export const GoogleMyBusinessIcon = createSVGComponentFromSVG(
    GoogleMyBusinessIconSvg,
    'GoogleMyBusinessIcon',
);
